// Centralized auth: attach the logged-in user's JWT to EVERY API request — for both
// `fetch` and `axios` — from ONE place, so we don't have to touch 100+ call sites.
// Installed once at app startup (see index.js). Only our API calls get the header; the
// token is read live from localStorage so it always reflects the current session.
import axios from 'axios';

function bearer() {
  const t = localStorage.getItem('access_token');
  return t ? `Bearer ${t}` : null;
}

// Only attach to our own API calls. Never to third parties (dicebear, typeform, S3, ...).
// Matches anything hitting our API base (apiUrl() output, incl. legacy un-namespaced routes
// like /send-report-email, /users, /admin/*) or a same-origin relative path. Previously this
// only matched a literal '/api/' substring, which silently dropped the token on every legacy
// route — blocking auth on exactly the endpoints the P0 hardening needs to gate.
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.careerstar.co';
function isApi(url) {
  if (typeof url !== 'string') return false;
  if (url.startsWith(API_BASE)) return true;   // our API (prod or dev base)
  if (url.startsWith('/')) return true;         // same-origin relative path (e.g. dev proxy)
  return false;                                 // third-party absolute URL -> never attach
}

export default function installAuth() {
  // --- axios (LogIn + a few dashboards use axios) ---
  axios.interceptors.request.use((config) => {
    const h = bearer();
    if (h && isApi(config.url || '')) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) config.headers.Authorization = h;
    }
    return config;
  });

  // --- fetch (most dashboards use fetch(apiUrl(...))) ---
  if (!window.__authFetchInstalled) {
    const orig = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isApi(url)) {
          const h = bearer();
          if (h) {
            const headers = new Headers(
              (init && init.headers) || (typeof input !== 'string' && input && input.headers) || {}
            );
            if (!headers.has('Authorization')) headers.set('Authorization', h);
            init = { ...(init || {}), headers };
          }
        }
      } catch (e) {
        // Never let auth-injection break a request.
      }
      return orig(input, init);
    };
    window.__authFetchInstalled = true;
  }
}
